/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_TaglineInputs */

const en_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat over your docs, tickets and data, with sources and no made-up answers.`)
};

const ar_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحادث حول مستنداتك وتذاكرك وبياناتك، مع المصادر ودون إجابات مختلقة.`)
};

const bn_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ডক, টিকিট আর ডেটা নিয়ে চ্যাট, সূত্রসহ আর বানানো উত্তর ছাড়াই।`)
};

const de_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatten Sie über Ihre Dokumente, Tickets und Daten, mit Quellen und ohne erfundene Antworten.`)
};

const es_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converse sobre sus documentos, tickets y datos, con fuentes y sin respuestas inventadas.`)
};

const fr_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discutez sur vos documents, tickets et données, avec sources et sans réponses inventées.`)
};

const pt_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converse sobre os seus documentos, tickets e dados, com fontes e sem respostas inventadas.`)
};

const zh_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于你的文档、工单和数据聊天，带出处，不编答案。`)
};

const tr_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeleriniz, biletleriniz ve verileriniz üzerinde sohbet, kaynaklı ve uydurmasız yanıtlarla.`)
};

const ru_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чат по вашим докам, тикетам и данным, с источниками и без выдуманных ответов.`)
};

const pl_svc_rag_knowledge_assistants_tagline = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czat po dokumentach, ticketach i danych, ze źródłami i bez zmyślonych odpowiedzi.`)
};

/**
* | output |
* | --- |
* | "Chat over your docs, tickets and data, with sources and no made-up answers." |
*
* @param {Svc_Rag_Knowledge_Assistants_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_tagline = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_tagline(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_tagline(inputs)
	return en_svc_rag_knowledge_assistants_tagline(inputs)
});
export { svc_rag_knowledge_assistants_tagline as "svc_rag-knowledge-assistants_tagline" }